/*
Author : Raphaël Dardeau


Setup : 

$(function() {
	$("[data-poll]").polling();
*/

;(function ( $, window, document, undefined ) {
    var pluginName = "polling",
        defaults = {
        	cookieName: 'poll-[id]',
        	cookieExpires: 3650,
        };		

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
        	this.setElements();
        	this.setVars();
			this.getCookie();
			this.setButtons();
            this.setComments();
            if (this.$element.data("poll-chart"))
                this.setChart(this.$element.data("poll-chart"));
			this.setEvents();
		},

        setElements: function () {
            this.$element = $(this.element);
            this.$buttons = this.$element.find(".js-poll-btn");
            this.$comments = $(".js-comments");
            this.$commentsPoll = $(".js-comments-poll");
        },

        setVars: function () {
            this.url = this.$element.data("poll");
            this.pollId = this.$element.data("poll-id");
            this.cookieName = this.settings.cookieName.replace("[id]", this.pollId);
            this.redirect = (this.$element.find(".js-poll-redirect").length) ? this.$element.find(".js-poll-redirect").attr("href"): false;
            this.showable = (typeof this.$element.data("poll-display")==='undefined' || this.$element.data("poll-display")==1);
        },
		
		getCookie: function() {
			var cookie = $.cookie(this.cookieName);
			if (cookie)
				this.vote = cookie;
			else
				this.vote = null;
		},

        setCookie: function() {
            $.cookie(this.cookieName, this.vote, {
                expires: this.settings.cookieExpires, 
                path: '/'
            });
        },

        setButtons: function() {
            if (this.vote) {
            	this.$element.addClass("is-polled")
            	this.$buttons.eq(this.vote - 1).addClass("is-active");
            }
        },

        setComments: function() {
            if (this.vote && this.$comments.length) {
                this.$commentsPoll.remove();
                this.$comments.show();
            }
        },

        setChart: function(datas) {
            if (this.vote && this.$element.find(".js-poll-chart").length) {
                if(this.showable){
                    this.$element.find(".js-poll-chart").attr("data-chart", JSON.stringify(datas)).charting();
                }else{
                    this.setMessageForChart(datas);
                }
            }
        },
        setMessageForChart: function(datas) {
            var message = "Votre vote a déjà été pris en compte";
            if(typeof datas!=='undefined' && datas.constructor!==Array) {
                try {
                    var json = JSON.parse(datas);
                } catch (err) {
                    this.$element.find(".js-poll-chart").html(datas);
                    this.$element.css('opacity',1);
                }
            }else{
                this.$element.find(".js-poll-chart").html('<span>'+message+'</span>');
                this.$element.css('opacity',1);
            }
        },

		setEvents: function() {
			this.$buttons.on("click", $.proxy(function (e) {
				if (!this.$element.hasClass("is-polled")) {
					this.vote = this.$buttons.index($(e.currentTarget)) + 1;
					this.setPoll();
				}
                if ($(e.currentTarget).attr("href"))
				    e.preventDefault();
			}, this));
		},

		setPoll: function() {
			if (this.$xhr)
				return false;

			this.url = this.url + "?provider=" + this.vote + "&id=" + this.pollId;
			this.$xhr = $.ajax(this.url).done($.proxy(function(json) {
                this.setButtons();
                this.setComments();
                if (json.datas) {
                    this.setChart(json.datas);
                }
                this.setCookie();

				if (this.redirect)
					document.location.href = this.redirect;
				this.$xhr = null;
			}, this));
		}
		
    });

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );